'use client';

import { LikeFilled } from '@depop/web-thrift-ui/Icons/LikeFilled';

import styles from './VisualSearchIllustration.module.css';

import { LocaleCurrencyFormat } from '@/components/LocaleCurrencyFormat';
import { CurrencyCode, currencyCodes } from '@/modules/currencies/constants';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import {
  VISUAL_SEARCH_LISTING_IMAGE,
  VISUAL_SEARCH_PHOTO_IMAGE,
} from '@/modules/visualSearch/constants';

const MATCH_CARD = {
  likes: '3',
  size: 'Small',
  price: 25,
  wasPrice: 35,
};

export function VisualSearchIllustration() {
  const { location } = useCurrentLocation();
  const currencyCode =
    currencyCodes[location.toUpperCase()] ?? CurrencyCode.GBP;

  return (
    <div className={styles.stage} aria-hidden="true">
      <div className={styles.composition}>
        <div className={styles.phone}>
          <img
            className={styles.photo}
            src={VISUAL_SEARCH_PHOTO_IMAGE}
            alt=""
          />
          <div className={styles.scan}>
            <span className={styles.lit} />
            <span className={styles.cornerTopLeft} />
            <span className={styles.cornerTopRight} />
            <span className={styles.cornerBottomLeft} />
            <span className={styles.cornerBottomRight} />
          </div>
        </div>
        <div className={styles.matchCard}>
          <div className={styles.listingImage}>
            <img src={VISUAL_SEARCH_LISTING_IMAGE} alt="" />
            <span className={styles.likes}>
              <span className={styles.likesIcon}>
                <LikeFilled size="sm" />
              </span>
              <em className={styles.likesCount}>{MATCH_CARD.likes}</em>
            </span>
          </div>
          <div className={styles.attributes}>
            <span className={styles.size}>{MATCH_CARD.size}</span>
            <span className={styles.price}>
              <span className={styles.priceNow}>
                <LocaleCurrencyFormat
                  numberToFormat={MATCH_CARD.price}
                  currencyCode={currencyCode}
                  stripDecimalsIfWholeNumber
                />
              </span>
              <span className={styles.priceWas}>
                <LocaleCurrencyFormat
                  numberToFormat={MATCH_CARD.wasPrice}
                  currencyCode={currencyCode}
                  stripDecimalsIfWholeNumber
                />
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
